// removed by extract-text-webpack-plugin
module.exports = {"primListItem":"_1GYd2","primListItemDetails":"_1JQQP _1GYd2","header":"_1K5Q_","info":"_3Ynya","intro":"_3hT02","profileList":"k_aub","profile":"_2r2ts","winnerFirstName":"_1Jtkw"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Details.scss
 ** module id = 35
 ** module chunks = 0
 **/